import { render } from "./i-uf.vue?vue&type=template&id=f06ff2fe"
import script from "./i-uf.vue?vue&type=script&lang=js"
export * from "./i-uf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__